import { Stack, InputField } from '@kiwicom/orbit-components';
import { FormattedMessage } from 'react-intl';
import { nullthrows } from '@adeira/js';

import Button from './Buttons/Button';
import showToast from './Toast/showToast';
import { ToastType } from './Toast/const';

type Props = {
  readonly link: string;
  readonly onCopy?: () => void;
  readonly context?: 'socialShare' | 'inviteTraveler';
};

const DeprecatedCopyForm = ({ link, onCopy, context = 'socialShare' }: Props): JSX.Element => {
  const copyLink = (text: string) => {
    const el = document.createElement('textarea');
    el.value = text;
    const body = nullthrows(document.body, 'Expected document to have a body, but it did not');
    body.appendChild(el);
    el.select();
    document.execCommand('copy');
    body.removeChild(el);
    showToast({
      translatedContent: (
        <FormattedMessage
          id="account_v2.settings.traveler_modal.invite_traveler.copied_to_clipboard"
          defaultMessage="Your invite link is copied and ready for sharing."
        />
      ),
      type: ToastType.SUCCESS,
    });

    if (onCopy != null) {
      onCopy();
    }
  };

  return (
    <Stack
      direction="column"
      tablet={{
        direction: 'row',
      }}
      spacing="300"
      spaceAfter="normal"
      flex
      align="end"
    >
      {context === 'socialShare' && (
        <InputField
          name="link"
          label={
            <FormattedMessage
              id="account_v2.settings.traveler_modal.invite_traveler.share_link"
              defaultMessage="Share this link:"
            />
          }
          placeholder={link}
          disabled
        />
      )}
      <Button fullWidth onClick={() => copyLink(link)}>
        <>
          {context === 'inviteTraveler' && (
            <FormattedMessage
              id="account_v2.settings.traveler_modal.invite_traveler.copy_invite_link"
              defaultMessage="Copy invite link"
              description="Designer: Anja Bošnjak; Figma: https://www.figma.com/file/NBrOoMbQ2PtvngYSxZmMje/Co-travelers?node-id=9966%3A136118"
            />
          )}
          {context === 'socialShare' && (
            <FormattedMessage
              id="account_v2.settings.traveler_modal.invite_traveler.copy_link"
              defaultMessage="Copy invite link"
            />
          )}
        </>
      </Button>
    </Stack>
  );
};

export default DeprecatedCopyForm;
